import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { creatorsVerificationSaga } from "./saga";

export const initialState = {
  creatorUsersInfo: {
    loading: false,
    error: null,
    users: [],
    status_counts: {},
    subscription_counts: {},
    creator_plans: [],
    pagination: {}
  },
  creatorUserDetails: {
    loading: false,
    error: null,
    user: null
  },
  updateCreatorInfo: {
    loading: false,
    error: null,
    success: false
  },
  brandFollowers: {
    loading: false,
    error: null,
    total: 0,
    logs: [],
    pagination: {},
    status_counts: {
      pending_approval: 0,
      approved: 0,
      rejected: 0
    }
  },
  reviewAction: {
    loading: false,
    error: null,
    success: false
  },
  restrictCreatorUser: {
    loading: false,
    error: null,
    success: false
  }
};

export const CreatorUsersSlice = createSlice({
  name: "creatorUsers",
  initialState,
  reducers: {
    fetchCreatorUsersRequest(state, action) {
      state.creatorUsersInfo.loading = true;
      state.creatorUsersInfo.error = null;
    },
    fetchCreatorUsersSuccess(state, action) {
      const {
        users,
        pagination,
        status_counts,
        subscription_counts,
        creator_plans
      } = action.payload;
      state.creatorUsersInfo.loading = false;
      state.creatorUsersInfo.users = users;
      state.creatorUsersInfo.pagination = pagination;
      state.creatorUsersInfo.status_counts = status_counts;
      state.creatorUsersInfo.subscription_counts = subscription_counts;
      state.creatorUsersInfo.creator_plans = creator_plans;
    },
    fetchCreatorUsersFailure(state, action) {
      state.creatorUsersInfo.loading = false;
      state.creatorUsersInfo.error = action.payload;
    },
    fetchCreatorUserByIdRequest(state, action) {
      state.creatorUserDetails.loading = true;
      state.creatorUserDetails.error = null;
    },
    fetchCreatorUserByIdSuccess(state, action) {
      state.creatorUserDetails.loading = false;
      state.creatorUserDetails.user = action.payload.user;
    },
    fetchCreatorUserByIdFailure(state, action) {
      state.creatorUserDetails.loading = false;
      state.creatorUserDetails.error = action.payload;
    },
    updateCreatorUserRequest(state, action) {
      state.updateCreatorInfo.loading = true;
      state.updateCreatorInfo.error = null;
      state.updateCreatorInfo.success = false;
    },
    updateCreatorUserSuccess(state, action) {
      state.updateCreatorInfo.loading = false;
      state.updateCreatorInfo.success = true;
    },
    updateCreatorUserFailure(state, action) {
      state.updateCreatorInfo.loading = false;
      state.updateCreatorInfo.error = action.payload;
    },

    fetchBrandFollowersRequest(state, action) {
      state.brandFollowers.loading = true;
      state.brandFollowers.error = null;
    },
    fetchBrandFollowersSuccess(state, action) {
      const { logs, pagination, total, status_counts } = action.payload;
      state.brandFollowers.loading = false;
      state.brandFollowers.logs = logs;
      state.brandFollowers.pagination = pagination;
      state.brandFollowers.total = total;
      state.brandFollowers.status_counts = status_counts;
    },
    fetchBrandFollowersFailure(state, action) {
      state.brandFollowers.loading = false;
      state.brandFollowers.error = action.payload;
    },

    lowFollowerReviewActionRequest(state, action) {
      state.reviewAction.loading = true;
      state.reviewAction.error = null;
      state.reviewAction.success = false;
    },
    lowFollowerReviewActionSuccess(state) {
      state.reviewAction.loading = false;
      state.reviewAction.success = true;
    },
    lowFollowerReviewActionFailure(state, action) {
      state.reviewAction.loading = false;
      state.reviewAction.error = action.payload;
    },
    resetReviewAction(state) {
      state.reviewAction = initialState.reviewAction;
    },

    restrictCreatorUserRequest(state) {
      state.restrictCreatorUser = {
        loading: true,
        error: null,
        success: false
      };
    },
    restrictCreatorUserSuccess(state, action) {
      const { userId, status } = action.payload || {};

      state.restrictCreatorUser = {
        loading: false,
        error: null,
        success: true
      };

      if (userId) {
        state.creatorUsersInfo.users = state.creatorUsersInfo.users.map(
          (user) =>
            user.id === userId
              ? { ...user, status } // or correct field name
              : user
        );
      }
    },
    restrictCreatorUserFailure(state, action) {
      state.restrictCreatorUser = {
        loading: false,
        error: action.payload,
        success: false
      };
    }
  }
});

export const useCreatorUsersSlice = () => {
  useInjectReducer(CreatorUsersSlice.name, CreatorUsersSlice.reducer);
  useInjectSaga(CreatorUsersSlice.name, creatorsVerificationSaga);
  const actions = useMemo(() => CreatorUsersSlice.actions, []);
  return { actions };
};

export const { actions: creatorUsersActions } = CreatorUsersSlice;
export default CreatorUsersSlice.reducer;
